import { useEffect } from "react";

import { useChatAvailability } from "@/features/tutor/hooks/useChatAvailability";
import { useChatSettingsStore } from "@/features/tutor/store/useChatSettingsStore";

export const useChatAvailabilitySync = (): void => {
  const { chatAvailable } = useChatAvailability();
  const setChatWindowOpen = useChatSettingsStore(
    (state) => state.setChatWindowOpen,
  );

  useEffect(() => {
    if (chatAvailable) return;
    if (!useChatSettingsStore.getState().chatWindowOpen) return;
    setChatWindowOpen(false, { force: true });
  }, [chatAvailable, setChatWindowOpen]);
};
